import { chakra, Flex, Box, Text, Button } from "@chakra-ui/react";

export const CardContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    borderRadius: "20px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#CDD6DC",
    p: "10px",
    width: "100%",
    minWidth: 0,
  },
});

export const HeaderSection = chakra(Flex, {
  baseStyle: {
    width: "100%",
    minHeight: "56px",
    gap: "8px",
    flexDirection: "column",
  },
});

export const TrendingTitle = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "1",
    letterSpacing: 0,
  },
});

export const CourseCardTitle = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "1",
    letterSpacing: 0,
    color: "#1819B4",
  },
});

export const CourseTitle = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "1",
    letterSpacing: 0,
  },
});

export const SubText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1",
    letterSpacing: 0,
    color: "#5C6670",
  },
});

export const NoCourseText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1",
    letterSpacing: 0,
  },
});

export const CertificateDowonloadButton = chakra(Button, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    width: "50%",
    border: "1px solid #1819B4",
    background: "#1819B4",
    borderRadius: "8px",
    height: "34px",
    color: "white",
    p: "2px 12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export const StartLearningButton = chakra(Flex, {
  baseStyle: {
    borderRadius: "8px",
    border: "1px solid #1819B4",
    p: "2px 12px",
    gap: "10px",
    minWidth: "unset",
    height: "34px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    verticalAlign: "middle",
    cursor: "pointer",
    backgroundColor: "#1819B4",
    color: "white",
    _hover: { backgroundColor: "#1819B4", color: "white" },
    role: "group",
  },
});

export const StartLearningText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "1",
    letterSpacing: 0,
    color: "inherit",
    _groupHover: { color: "white" },
  },
});

export const CourseListSection = chakra(Flex, {
  baseStyle: {
    width: "100%",
    flexDirection: "column",
    gap: "12px",
    mt: "16px",
  },
});

export const NoRecentCourseOuter = chakra(Flex, {
  baseStyle: {
    w: "100%",
    gap: "10px",
    minWidth: 0,
    position: "relative",
  },
});

export const NoRecentCourseCard = chakra(Flex, {
  baseStyle: {
    height: "162px",
    borderRadius: "20px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#CDD6DC",
    gap: "40px",
    bg: "#F9F8FF",
    width: "100%",
    minWidth: 0,
    align: "center",
  },
});

export const NoRecentCourseLeft = chakra(Box, {
  baseStyle: {
    flex: "1 1 0",
    minWidth: 0,
    paddingLeft: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    maxWidth: "50%",
  },
});

export const NoRecentCourseTitleBox = chakra(Box, {
  baseStyle: {
    width: "100%",
    maxWidth: "650px",
    height: "60px",
    display: "flex",
    alignItems: "center",
  },
});

export const NoRecentCourseTitle = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: 1,
    letterSpacing: 0,
    wordBreak: "break-word",
  },
});

export const NoRecentCourseButton = chakra(Flex, {
  baseStyle: {
    width: "167px",
    height: "34px",
    padding: "2px 12px",
    gap: "10px",
    borderRadius: "8px",
    background: "#1819B4",
    border: "1px solid #000000",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 500,
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
});

export const NoRecentCourseRight = chakra(Box, {
  baseStyle: {
    flex: "1 1 0",
    minWidth: 0,
    position: "relative",
    height: "100%",
    maxWidth: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const NoRecentCourseBg = chakra(Box, {
  baseStyle: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
  },
});

export const NoRecentCourseBadge = chakra(Box, {
  baseStyle: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  },
});

export const NoRecentCourseStars = chakra(Box, {
  baseStyle: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    pointerEvents: "none",
  },
});

export const CourseLayoutContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "row",
    borderRadius: "8px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#CDD6DC",
    p: "12px 16px",
    width: "100%",
    justify: "space-between",
    minWidth: 0,
    mb: "8px",
    align: "center",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const CourseLayoutLeft = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    gap: "16px",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
});

export const CourseName = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "1",
    letterSpacing: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

export const CourseProgressRow = chakra(Flex, {
  baseStyle: {
    flexDirection: "row",
    gap: "12px",
    align: "center",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
});

export const CourseProgressText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1",
    letterSpacing: 0,
    color: "#5C6670",
  },
});

export const ContinueButton = chakra(Flex, {
  baseStyle: {
    borderRadius: "8px",
    border: "1px solid #1819B4",
    height: "32px",
    p: "6px 12px",
    cursor: "pointer",
    color: "#1819B4",
    alignItems: "center",
    justifyContent: "center",
    _hover: {
      backgroundColor: "#1819B4",
      color: "white",
    },
  },
});

export const ContinueButtonText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "1",
    letterSpacing: 0,
    color: "inherit",
    textAlign: "center",
    verticalAlign: "middle",
  },
});

export const CompletedButton = chakra(Flex, {
  baseStyle: {
    height: "32px",
    p: "6px 12px",
    borderRadius: "48px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#00A177",
    bg: "#00A1771A",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const CompletedButtonText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "1",
    letterSpacing: 0,
    color: "#00A177",
    textAlign: "center",
    verticalAlign: "middle",
  },
});

export const DashboardHeaderContainer = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
    p: "20px 24px 20px 24px",
  },
});

export const DashboardHeaderLeft = chakra(Flex, {
  baseStyle: {
    gap: "12px",
    alignItems: "center",
  },
});

export const DashboardHeaderTitle = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "#232323",
    whiteSpace: "nowrap",
  },
});

export const DashboardHeaderOrgBox = chakra(Flex, {
  baseStyle: {
    display: "flex",
    flexDirection: "row",
    height: "26px",
    pt: "4px",
    pr: "6px",
    pb: "4px",
    pl: "6px",
    gap: "1px",
    borderRadius: "35px",
    borderWidth: "0.5px",
    borderStyle: "solid",
    borderColor: "#00A177",
    bg: "#00A1771A",
    alignItems: "center",
    verticalAlign: "middle",
  },
});

export const DashboardHeaderOrgText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "#00A177",
    px: "4px",
    borderRadius: "2px",
    whiteSpace: "nowrap",
  },
});

export const DashboardHeaderRightButton = chakra(Flex, {
  baseStyle: {
    minWidth: "139px",
    height: "34px",
    pt: "2px",
    pr: "6px",
    pb: "2px",
    pl: "6px",
    gap: "2px",
    borderRadius: "8px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#1819B4",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    color: "#1819B4",
    cursor: "pointer",
  },
});

export const DashboardHeaderRightText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    bg: "inherit",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0%",
    textAlign: "center",
    color: "inherit",
    px: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: "2px",
    whiteSpace: "nowrap",
  },
});
